"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BondNFT__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
            {
                internalType: "address",
                name: "_initialArtworkAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_transferLockoutPeriodSeconds",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "troveManagerAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "lqtyToken",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "lqtyStaking",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "pickleLQTYJar",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "pickleLQTYFarm",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "curveGaugeController",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "curveLUSD3CRVGauge",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "curveLUSDFRAXGauge",
                        type: "address",
                    },
                ],
                internalType: "struct BondNFT.LiquityDataAddresses",
                name: "_liquityDataAddresses",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "CURVE_GAUGE_SLOPES_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "artwork",
        outputs: [
            {
                internalType: "contract IBondNFTArtwork",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chickenBondManager",
        outputs: [
            {
                internalType: "contract IChickenBondManager",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "curveGaugeController",
        outputs: [
            {
                internalType: "contract ICurveGaugeController",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "curveLUSD3CRVGauge",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "curveLUSDFRAXGauge",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "getBondAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "getBondClaimedBLUSD",
        outputs: [
            {
                internalType: "uint256",
                name: "claimedBLUSD",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "getBondEndTime",
        outputs: [
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "getBondExtraData",
        outputs: [
            {
                internalType: "uint80",
                name: "initialHalfDna",
                type: "uint80",
            },
            {
                internalType: "uint80",
                name: "finalHalfDna",
                type: "uint80",
            },
            {
                internalType: "uint32",
                name: "troveSize",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "lqtyAmount",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "curveGaugeSlopes",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "getBondFinalDna",
        outputs: [
            {
                internalType: "uint256",
                name: "finalDna",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "getBondFinalHalfDna",
        outputs: [
            {
                internalType: "uint80",
                name: "finalHalfDna",
                type: "uint80",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "getBondInitialDna",
        outputs: [
            {
                internalType: "uint256",
                name: "initialDna",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "getBondInitialHalfDna",
        outputs: [
            {
                internalType: "uint80",
                name: "initialHalfDna",
                type: "uint80",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "getBondStartTime",
        outputs: [
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "getBondStatus",
        outputs: [
            {
                internalType: "uint8",
                name: "status",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lqtyStaking",
        outputs: [
            {
                internalType: "contract ILQTYStaking",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lqtyToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_bonder",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_permanentSeed",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pickleLQTYFarm",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pickleLQTYJar",
        outputs: [
            {
                internalType: "contract IPickleJar",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_chickenBondManagerAddress",
                type: "address",
            },
        ],
        name: "setAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_artworkAddress",
                type: "address",
            },
        ],
        name: "setArtworkAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_bonder",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_permanentSeed",
                type: "uint256",
            },
        ],
        name: "setFinalExtraData",
        outputs: [
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenID",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "transferLockoutPeriodSeconds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "troveManager",
        outputs: [
            {
                internalType: "contract ITroveManager",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class BondNFT__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(name_, symbol_, _initialArtworkAddress, _transferLockoutPeriodSeconds, _liquityDataAddresses, overrides) {
        return super.deploy(name_, symbol_, _initialArtworkAddress, _transferLockoutPeriodSeconds, _liquityDataAddresses, overrides || {});
    }
    getDeployTransaction(name_, symbol_, _initialArtworkAddress, _transferLockoutPeriodSeconds, _liquityDataAddresses, overrides) {
        return super.getDeployTransaction(name_, symbol_, _initialArtworkAddress, _transferLockoutPeriodSeconds, _liquityDataAddresses, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BondNFT__factory = BondNFT__factory;
BondNFT__factory.bytecode = _bytecode;
BondNFT__factory.abi = _abi;
